import React from 'react';
import orderActions from '../../../redux/futures/order/actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import Spinner from '../../../components/Spinner';
import baseHelper from '../../../helpers/BaseHelper';
import appConst from '../../../config/const';
import * as types from '../../../redux/futures/order/types';
import i18n from '../../../i18n';

class Detail extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            order: {
                ladi_uid: '',
                id: '',
                reference_no: '',
                discount: '',
                total: '', 
                note: '',
                status: '' 
            },
            details: []
        }
    }

    // componentDidMount() {
    //     this.getDetail();
    // }

    componentDidUpdate() {
        window.LadiUI.init();
    }


    componentWillReceiveProps(nextProps) {
        

        if (this.props.currentPayment !== nextProps.currentPayment) {
            this.setState({
                order: _.pick(nextProps.currentPayment, _.keys(this.state.order))
            })
        }



        if (_.includes([types.DETAIL_ORDER], nextProps.action)) {
            if (nextProps.status) {

                this.setState({
                    details: nextProps.details,
                });
            } else {
            }
        }
    } 

    render() {
        const { details } = this.state;
        

        return (
            <div id="modal-detail" className="ladiui modal fade" tabIndex={-1} data-dismiss="modal-detail">
                <div className="ladiui-modal-content" style={{ maxWidth: '1100px' }}>
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-detail"><i className="ladi-icon icon-e-remove" data-dismiss="modal-detail" /></button>
                        <h3>{i18n.t('ORDER.REFERENCE_NO')}: {this.state.order.reference_no}
                        
                        </h3>
                        
                    </div>
                    <div className="ladiui-modal-body">
                        
                            <div className="order-box"  style={{width:'1070px',margin:'15px'}}>
                                {/* <ul> */} 
                                    {/* <div className="ladiui-row" style={{height:'50px'}}> */}
                                        
                                        {/* <div className="col-50">
                                            <strong>{i18n.t('ORDER.AMOUNT')}: </strong>
                                            {
                                                this.state.order.total && this.state.order.total.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
                                            }
                                        </div> */}
                                  
                                        
                                        {/* <div className="col-50">
                                            <strong>{i18n.t('ORDER.DISCOUNT')}: </strong>
                                            {
                                                this.state.order.discount
                                            }
                                        </div> */}
                                    {/* </div> */}
                                    {/* <div className="ladiui-row" style={{height:'50px'}}>
                                        <div className="col-50">
                                            <strong>{i18n.t('ORDER.NOTE')}: </strong>{this.state.order.note}
                                        </div>
                                        <div className="col-50">
                                            <strong>{i18n.t('COMMON.STATUS')}: </strong>
                                            {
                                                this.state.order.status != '' &&
                                                i18n.t(appConst.PAYMENT_STATUS_OPTIONS[this.state.order.status].name)
                                            }
                                                        
                                        </div>
                                    </div> */}
                                     
                                    {/* <li><strong>admin_id: ''</strong>{this.state.admin_id}</li> */}

                                {/* </ul> */}
                                {this.props.loading && <Spinner />}
                            </div>
                        
                    </div>
                    <table className="ladiui table">
                        <thead>
                            <tr>
                                {/* <th className="text-left">{i18n.t('ORDER.STORE_ID')}</th> */}
                                <th className="text-left">{i18n.t('ORDER.STORE_NAME')}</th>
                                <th className="text-left">{i18n.t('PACKAGE.APP')}</th>
                                <th className="text-left">{i18n.t('PACKAGE.NAME')}</th>
                                <th className="text-left">{i18n.t('PACKAGE.MONTH')}</th>
                                <th className="text-left">{i18n.t('PACKAGE.ADDITION_MONTH')}</th>
                                {/* <th className="text-center">{i18n.t('PACKAGE.COMMISSION_TYPE')}</th> */}
                                {/* <th className="text-center">{i18n.t('PACKAGE.COMMISSION_VALUE')}</th> */}
                                <th className="text-left">{i18n.t('PACKAGE.TOTAL_PRICE')}</th>
                                <th className="text-left">{i18n.t('PACKAGE.CREATED_AT')}</th>
                                {/* <th className="text-center">{i18n.t('PACKAGE.DISCOUNT_TYPE')}</th> */}
                                {/* <th className="text-center">{i18n.t('PACKAGE.DISCOUNT_VALUE')}</th> */}
                                {/* <th></th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                _.map(details, detail => {
                                    return <tr key={detail._id}>
                                        {/* <td>{detail.store_id}</td> */}
                                        <td>{detail.store_name}</td>
                                        <td>{appConst.APP[detail.pkg_type]}</td>
                                        <td>{detail.pkg_name}</td>
                                        <td>{detail.pkg_month}</td>
                                        <td>{detail.addition_month}</td>
                                        {/* <td>{detail.pkg_commission_type}</td> */}
                                        {/* <td>{detail.pkg_commission_value}</td> */}
                                        <td>{baseHelper.formatNumber(detail.subtotal)} VND</td>
                                        <td>{baseHelper.formatStrToDate(detail.created_at)}</td>
                                        {/* <td>{detail.discount_type}</td> */}
                                        {/* <td>{detail.discount_value}</td> */}
                                    </tr>
                                }
                                )
                            }
                        </tbody>
                    </table>

                    <div className="ladiui-modal-footer">

                        {this.props.loading && <Spinner />}
                    </div>
                </div>

            </div >
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getDetail: (order) => dispatch(orderActions.getDetail(order))
    }
}

const mapStateToProps = (state) => ({ ...state.order });

export default connect(mapStateToProps, mapDispatchToProps)(Detail);